import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import AttivaCard from '../../../components/card/AttivaCard';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import { ProductService } from "../../../services/product/productService";
import { formatValidationError, PRODUCT_FIELD_LABELS } from '../../../utils/validationErrorLabels';
import ProductForm from "../ProductForm";

const pageHeader = {
    title: 'Crear Producto',
    breadcrumb: [
        { name: 'Administración' },
        { name: 'Gestión de productos' },
        { href: menuRoutes.products.path, name: 'Productos' },
        { name: 'Crear' },
    ],
};

export default function ProductCreate() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);

    const handleSubmit = async (values: any) => {
        setLoading(true);
        try {
            const {
                contractWatermarkFile,
                removeContractWatermark,
                ...payload
            } = values;

            const service = new ProductService();
            const response = await (await service.createProduct(payload)).getResponseData();
            if (response.success) {
                const createdProductId = response.data?.id;
                if (createdProductId && contractWatermarkFile) {
                    const uploadResponse = await (
                        await service.updateContractWatermark(createdProductId, contractWatermarkFile, removeContractWatermark)
                    ).getResponseData();

                    if (!uploadResponse.success) {
                        toast.error(uploadResponse.message ?? 'El producto se ha creado, pero no se ha podido guardar la marca de agua');
                    }
                }

                setLoading(false);
                navigate(-1);
                setTimeout(() => {
                    toast.success('Producto creado');
                }, 100)
            } else {
                response.data.errors?.forEach((error: any) => {
                    toast.error(formatValidationError(error, PRODUCT_FIELD_LABELS));
                });
            }
        } catch (error: any) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <AttivaCard title='Datos Principales' className='mb-4'>
                <ProductForm submit={handleSubmit} isLoading={loading} />
            </AttivaCard>
        </>
    );
}
